import(/* webpackMode: "eager", webpackExports: ["Spin"] */ "__barrel_optimize__?names=Spin!=!/data/jenkins-new/workspace/web-server/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/data/jenkins-new/workspace/web-server/packages/core/components/Locale/LocaleContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/jenkins-new/workspace/web-server/packages/web-ssr/src/app/[lang]/support/_components/Article/ClientArticle.tsx");
